import React from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button, Chip,
} from '@mui/material';
import Add from '@mui/icons-material/Add';

export default function PaymentConditions() {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">Condiciones de Pago</Typography>
        <Button variant="contained" startIcon={<Add />}>Nueva Condicion</Button>
      </Box>

      <Typography variant="body1" color="textSecondary" gutterBottom>
        Gestion de las condiciones de cobro al cliente asociadas a hitos del proyecto.
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Descripcion</TableCell>
              <TableCell align="right">% del Total</TableCell>
              <TableCell align="right">Importe</TableCell>
              <TableCell>Hito Asociado</TableCell>
              <TableCell>Fecha Vencimiento</TableCell>
              <TableCell>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography color="textSecondary">No hay condiciones de pago definidas</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
